<template>
    <!--
    作者：bbc_team
    时间：2023-06-08
    描述：插件中心-积分商城-商品设置-添加商品
  -->
    <div class="pb50">
        <el-form v-if="!loading" ref="form" size="small" :model="form" label-width="150px">

            <el-form-item label="活动名称" prop="activity">{{ form.activity.title }}</el-form-item>
            <el-form-item label="合作类型" prop="cooperate_type_name">{{ form.cooperate_type_name }}</el-form-item>
            <el-form-item label="单位类型" prop="info_type_name">{{ form.info_type_name }}</el-form-item>
            <el-form-item label="单位名称/姓名" prop="name">{{ form.name }}</el-form-item>
            <el-form-item label="地址" prop="name">{{ form.address }}</el-form-item>
            <el-form-item label="联系人" prop="name">{{ form.link_user }}</el-form-item>
            <el-form-item label="手机号码" prop="name">{{ form.phone }}</el-form-item>
            <el-form-item label="业务员" prop="name">{{ form.salesman }}</el-form-item>
            <el-form-item label="创建时间" prop="name">{{ form.create_time }}</el-form-item>

            <el-form-item label="审核状态：" :rules="[{ required: true, message: '选择审核状态' }]" prop="status">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">通过</el-radio>
                    <el-radio :label="-1">未通过</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="不通过原因：">
                <el-input v-model="form.r_msg" type="textarea" min="0" class="mb16 max-w460"
                          placeholder="请输入审核不通过原因"></el-input>
            </el-form-item>

            <!--提交-->
        </el-form>
        <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
        </div>
    </div>
</template>
<script>
import PlatformActivityApi from "@/api/platformactivity.js";
import {formatModel} from "@/utils/base.js";

export default {
    components: {},
    provide: function () {
        return {
            form: this.form,
            type: "add"
        };
    },
    data() {
        return {
            /*是否正在加载*/
            loading: true,
            old_audit: 0,
            /*表单*/
            form: {
                cooperate_type_name: '',
                cooperate_type: '',
                info_type_name: '',
                info_type: '',
                name: '',
                address: '',
                link_user: '',
                phone: '',
                salesman: '',
                status: '',
                r_msg: '',
                user_id: '',
                sh_id: '',
                sh_time: '',
            }
        };
    },
    created() {
        this.form.cooperate_id = this.$route.query.cooperate_id;
        this.getData();
    },
    methods: {
        getData() {
            let self = this;
            PlatformActivityApi.cooperate.detail(
                {
                    cooperate_id: self.form.cooperate_id
                },
                true
            ).then((res) => {
                self.form = res.data.detail;
                self.loading = false;
            });
        },

        /*提交表单*/
        onSubmit() {
            let self = this;
            self.$refs.form.validate((valid) => {
                if (valid) {
                    self.loading = true;
                    PlatformActivityApi.cooperate.stateSet(self.form, true)
                        .then((data) => {
                            self.loading = false;
                            self.$message({
                                message: "审核成功",
                                type: "success"
                            });
                            self.cancelFunc();
                        })
                        .catch((error) => {
                            self.loading = false;
                        });
                }
            });
        },

        /*表格数据格式化*/
        tableFormet(list) {
            list.forEach((item) => {
                item.goods_attr = item.spec_name;
            });
            return list;
        },

        /*取消*/
        cancelFunc() {
            this.$router.back(-1);
        }
    }
};
</script>
<style>
.edit_container {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.ql-editor {
    height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/cooperate/edit.vue